import { Common, Accessors } from "../../../helper";

const reportColunms = [
  {
    Header: Common.Report,
    accessor: Accessors.Report,
  },
  {
    Header: Common.CreatedAt,
    accessor: Accessors.CreatedAt,
  },
  {
    Header: Common.UpdatedAt,
    accessor: Accessors.UpdatedAt,
  },

  {
    Header: Common.SchoolYear,
    accessor: Accessors.SchoolYear,
  },
  {
    Header: Common.View,
    accessor: Accessors.View,
  },
];

export { reportColunms };